import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from '@blaze-cms/nextjs-components';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { buildAdminHref, setBlazeDebug } from '../../helpers';
import { DEBUG_LOGO } from '../../constants';
const DebugSidebar = ({
  itemEntity,
  itemId,
  debugMode
}) => {
  const [isDebugMode, setIsDebugMode] = useState(debugMode);
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    if (debugMode === true) {
      setIsDebugMode(debugMode);
    } else setBlazeDebug(setIsDebugMode);
  }, [debugMode]);
  const divClass = classnames('debug-sidebar', {
    'debug-sidebar--open': isOpen,
    'debug-sidebar--close': !isOpen
  });
  const href = buildAdminHref({
    itemEntity,
    itemId
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isDebugMode ? /*#__PURE__*/React.createElement("div", {
    className: divClass,
    "data-testid": "debug-sidebar"
  }, /*#__PURE__*/React.createElement(Link, {
    href: href
  }, /*#__PURE__*/React.createElement("img", {
    src: DEBUG_LOGO.SRC,
    alt: DEBUG_LOGO.ALT
  }), /*#__PURE__*/React.createElement("span", null, "Blaze admin")), /*#__PURE__*/React.createElement("div", {
    role: "button",
    className: "debug-sidebar__button open",
    "data-testid": "debug-sidebar-button",
    id: "debug-sidebar-button",
    onClick: () => setIsOpen(!isOpen)
  }, /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(MdKeyboardArrowLeft, null)))) : null);
};
DebugSidebar.propTypes = {
  itemEntity: PropTypes.string,
  itemId: PropTypes.string,
  debugMode: PropTypes.bool
};
DebugSidebar.defaultProps = {
  itemEntity: '',
  itemId: '',
  debugMode: false
};
export default DebugSidebar;
//# sourceMappingURL=index.js.map